import { Box, Modal } from "@mui/material";
import React from "react";
import cssClasses from "./ViewLeadDetails.module.css";
import { makeStyles } from "@mui/styles";
import Button from "../../Subcomponents/Button";
import Close from "../../Components/Icons/Close";


const useStyles = makeStyles((theme) => ({
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  heading: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.6rem",
    lineHeight: "2rem",
    color: "#101828",
    padding:"0.4rem 1rem",
    marginBottom: "0.4rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.6rem",
    lineHeight: "2rem",
    color: "#667085",
    paddingLeft:"1rem",
    padding:"0.4rem 1rem",
  }
}));
const ViewLeadDetailsRL = ({ open, handleClose, data ,dataAll,referalDetailsData}) => {
  const classes = useStyles();
  function closeModal() {
    handleClose();
  }
  
    return (
        <Modal
            open={open}
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    closeModal();
                }
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={[
                {
                    ".MuiBackdrop-root": {
                        background: "rgba(52, 64, 84, 0.7)",
                    },
                },
            ]}
            disableAutoFocus={true}
        >
            <Box className={cssClasses.modalWrapper}>
                <div className={cssClasses.wrapperHeader}>
                    <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
                        <Close width={"1.2rem"} height={"1.2rem"} />
                    </span>
                    <div className={classes.heading}>R&L Lead Referral Details</div>
                </div>
             
<div  className={cssClasses.keyValue}>
  <table className={classes.table}>
    <tbody>
      <tr>
        <td className={classes.title}>Referral Name</td>
        <td className={classes.subTitle}>{data?.name ? data?.name : dataAll.referrername ? dataAll.referrername : "NA"}</td>
      </tr>
      <tr>
        <td className={classes.title}>Relationship</td>
        <td className={classes.subTitle}>{data?.relationship ? data?.relationship  : referalDetailsData?.leadRelationship? referalDetailsData?.leadRelationship : "NA"}</td>
      </tr>
      <tr>
        <td className={classes.title}>Type</td>
        <td className={classes.subTitle}>{data?.type ? data?.type : "NA"}</td>
      </tr>
      <tr>
        <td className={classes.title}>Referral Mobile Number</td>
        <td className={classes.subTitle}>{data?.contactNumber ? data?.contactNumber: referalDetailsData?.leadReferrerMobile? referalDetailsData?.leadReferrerMobile  : "NA"}</td>
      </tr>
      <tr>
        <td className={classes.title}>Remarks</td>
        <td className={classes.subTitle}>{data?.remarks ? data?.remarks : referalDetailsData?.remark? referalDetailsData?.remark : "NA"}</td>
      </tr>
      <tr>
        <td className={classes.title}>Project Name</td>
        <td className={classes.subTitle}>{data?.projectName ? data?.projectName : dataAll?.referrerproject ? dataAll?.referrerproject : "NA"}</td>
      </tr>
      <tr>
        <td className={classes.title}>Wing</td>
        <td className={classes.subTitle}>{data?.wingName ? data?.wingName : dataAll?.referrerwing ? dataAll?.referrerwing : "NA"}</td>
      </tr>
      <tr>
        <td className={classes.title}>Unit Number</td>
        <td className={classes.subTitle}>{data?.unitNo ? data?.unitNo : dataAll?.referrerunitno ? dataAll?.referrerunitno : "NA"}</td>
      </tr>
     
    </tbody>
  </table>
</div>

        <div className={cssClasses.wrapperFooter}>
          <Button
            style={{
              color: "#ffffff",
              backgroundColor: "#155EEF",
              fontSize: "1.6rem",
              lineHeight: "2.4rem",
              width: "auto",
            }}
            btnName={"OK"}
            clicked={() => {
              closeModal();
            }}
          />
        </div>
      </Box>
    </Modal>
  );
};

export default ViewLeadDetailsRL;
